<template></template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import { recordingResumedNotification } from './notifications'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    props: [
      'channel'
    ],
    created () {
      this.channel.bind('recording.resumed', () => {
        this.markRecordingState('in-progress')
        this.markRecordingButtonDisabled(false)
        recordingResumedNotification().show()
      })
    },
    methods: mapActions([
      'markRecordingState',
      'markRecordingButtonDisabled'
    ])
  }
</script>



// WEBPACK FOOTER //
// recording-resumed.vue?5c09bc81